{
	"forms": {
		"minimum_value_is": "Minimum value is {{val}}",
		"maximum_value_is": "Maximum value is {{val}}"
	},
	"general": {
		"login": "Log in",
		"email": "Email",
		"password": "Password",
		"error_connecting_to_server": "Error connecting to server",
		"required": "Required",
		"logging_in": "Logging in...",
		"something_went_wrong": "Something went wrong",
		"forgot_your_password": "Forgot your password?",
		"register": "Register",
		"send_message": "Send message",
		"message_history": "Message history",
		"contacts": "Contacts",
		"credits": "Credits",
		"account": "Account",
		"customer_service": "Customer service",
		"log_out": "Log out",
		"really_log_out": "Are you sure you want to log out?",
		"expiring_information": "Purchased credits expire one year from the date of purchase. Credit expiration can be prevented by purchasing additional credits.",
		"cancel": "Cancel",
		"loading": "Loading...",
		"home": "Home",
		"welcome_use_tavoittaja": "Welcome to Tavoittaja!",
		"credits_to_use": "credits",
		"buy_credits": "Buy credits",
		"send_message_guide": "You can send text messages to your saved groups or specify the recipients manually. You can also schedule the message to be sent at a later time. Please make sure you have credits on your account before creating the message to ensure it can be sent.",
		"did_you_know": "Did you know...",
		"continue_to_confirm": "Confirm and select sending time",
		"sender": "Sender",
		"message": "Message",
		"credits_per_message": "credits per message",
		"characters": "characters",
		"receivers": "Receivers",
		"groups": "Groups",
		"subject": "Subject",
		"send_message_to_customer_service": "Send message to customer service",
		"customer_service_info_text": "Here you can contact our customer service with the form below.",
		"phone_number_short": "Phone",
		"support_open_times": "(mon - fri 09.00-17.00)",
		"service_is_owned_by": "Tavoittaja is managed by",
		"thanks_for_message": "Thanks!",
		"we_will_contact_asap": "We will contact you as soon as possible.",
		"account_guide": "Remember to keep account information up to date.",
		"first_name": "First name",
		"inbound_numbers": "Inbound numbers",
		"last_name": "Last name",
		"phone": "Phone number",
		"save": "Save",
		"account_information": "Account information",
		"name": "Name",
		"businessID": "Business ID",
		"city": "City",
		"postal_code": "Postal code",
		"postal_address": "Postal address",
		"saved": "Saved",
		"please_wait": "Please wait...",
		"oops_something_went_wrong": "Oops! Something went wrong",
		"unexpected_error": "An unexpected error happened.",
		"we_are_informed": "We are informed of this error, and will be fixing it as soon as possible.",
		"reload_page": "Reload page",
		"new_password": "New password",
		"new_password_again": "New password again",
		"change_your_accounts_password": "Change your accounts password",
		"password_guide": "When creating a new password, make sure it is at least 6 characters long. Try to use a combination of numbers, letters, and punctuation marks.",
		"change_password": "Change password",
		"api": "API",
		"users": "Users",
		"passwords_do_not_match": "Passwords do not match",
		"select_credit_amount": "Select credit amount",
		"select_amount_manually": "Or enter amount manually",
		"amount_short": "pcs",
		"select_payment_method": "Select payment method",
		"online_payment": "Online payment (Paytrail)",
		"payment_details": "Payment details",
		"price_without_vat": "Price without VAT",
		"vat": "VAT 25.5%",
		"payment_fee": "Invoice fee",
		"total": "Total",
		"use_discount_code": "Use discount code",
		"continue_to_pay": "Pay",
		"buy_atleast_500_credits": "You must buy at least 500 credits.",
		"enter_code": "Enter code",
		"apply": "Apply",
		"discount_applied": "Discount applied",
		"buy_credits_guide": "You need credits to send text messages. One text message credit corresponds to one standard-length text message. You can pay for the purchase via online payment or invoice. Credits are valid for 365 days from the latest purchase, and minimum purchase is 500 pcs.",
		"credit_buy_history": "History",
		"history_guide": "Below you can see credit buy history.",
		"select_account": "Select which account you want to login to",
		"password_must_be_at_least_8_characters": "Password must be at least 8 characters long.",
		"account_has_credits": "You currently have {{credits}} credits.",
		"admin": "Admin",
		"oops_not_found": "Oops! The page you are looking for doesn’t exist.",
		"this_page_does_not_exist": "It looks like you've wandered off the beaten path. Let's get you back on track.",
		"go_to_homepage": "Go to homepage",
		"phone_in_international_format": "Phone number in international format (+358 123 456 789)",
		"recover_password": "Recover password",
		"recover_password_guide": "Enter the email associated with your account and we'll send an email with a link to reset your password.",
		"go_back": "Go back",
		"send_recovery_email": "Send recovery email",
		"check_your_email": "Check your email",
		"we_have_sent_recovery_details": "If an account with that email exists, we have sent password recovery link to your email.",
		"back_to_login": "Go back",
		"set_a_password": "Set a new password",
		"invalid_token": "Invalid or expired link. Make sure you copied the whole link.",
		"password_recovery_done": "All done. You can now login with the new password",
		"register_guide_1": "Getting started with the service is quick and free.",
		"credit_offer": "The 100 credit introductory offer applies only to new business and association customers. You will receive the credits, when your account has been approved by us.",
		"you_must_represent_organization": "Note: You must have the authority to represent the organization in whose name the account is opened.",
		"password_again": "Password again",
		"organization": "Company/association",
		"really_go_back": "You have not registered yet. Really go back?",
		"have_read_terms": "I have read and accepted ",
		"service_is_meant_for": "The service is intended for communication and marketing by businesses and organizations. It is not intended for communication between private individuals.",
		"terms_and_conditions": "the terms and conditions",
		"no_account_yet": "No account? ",
		"register_done": "We created an account for you and sent a link to your email, where you can complete the remaining details. You can now close this page.",
		"register_successful": "Registration successful",
		"personal_information": "Personal information",
		"create_user": "Create user",
		"create_user_successful": "User created successfully",
		"you_can_now_login": "You can now log in.",
		"inbound_numbers_guide": "Enable two-way messaging by reserving your own sending number. When you send a message from your reserved number, the recipient can reply to it.",
		"contact_customer_service_to_order_inbound_number": "Inbound numbers are priced at 49€ per month before VAT.",
		"api_guide": "You can also integrate SMS sending into your own systems using API credentials.",
		"contact_email": "Contact email",
		"contact_email_guide": "If we make changes to the API, we will notify this email address.",
		"guide": "Instructions",
		"company": "Company",
		"sort_asc": "Sort ascending",
		"true": "Yes",
		"sort_desc": "Sort descending",
		"choose_visible_columns": "Choose visible columns",
		"search": "Search",
		"clear": "Clear",
		"paytrail_payment_terms": "Paytrail payment terms",
		"no_data": "No data",
		"time_created": "Time created",
		"vat_code": "VAT code",
		"billing_email": "Email address where order confirmations and receipts are sent",
		"billing_email_with_invoicing": "Email address where order confirmations, receipts, and any invoices are sent",
		"order": "Order",
		"order_id": "Order ID",
		"product_info": "Product info",
		"total_without_vat": "Total without VAT",
		"payment_method": "Payment method",
		"invoice": "Invoice",
		"receiver": "Receiver",
		"payer": "Payer",
		"buy_date": "Order date",
		"product": "Product",
		"open_receipt": "Open receipt",
		"price_does_not_include_vat": "(Price does not include VAT 25.5%)",
		"regular": "Regular user",
		"role": "Role",
		"users_guide": "Browse, add, edit and remove users and their information.",
		"edit": "Edit",
		"is_admin": "Is admin",
		"cannot_edit_your_own_role": "You cannot change your own role.",
		"you_can_only_edit_other_users_role": "You can only edit other users role.",
		"remove_from_account": "Remove",
		"remove": "Remove",
		"remove_user": "Remove user",
		"really_remove_user": "Really remove this user from your account?",
		"add_user": "Add user",
		"job_title": "Job title",
		"import_from_file": "Import from file",
		"custom_fields": "Custom fields",
		"message_templates": "Message templates",
		"schedule_send": "Schedule send",
		"manual_receivers_guide": "Enter each number on its own line or separate them with a comma.",
		"click_to_set_date_and_time": "Click to set date and time",
		"message_templates_guide": "Message templates",
		"contacts_amount": "active contacts",
		"contact_amount": "active contact",
		"groups.with_0_contacts_are_not_shown": "Groups with no active contacts cannot be selected.",
		"send_now": "Send now",
		"send": "Send",
		"character_count": "Character count",
		"drafts": "Drafts",
		"drafts_guide": "Drafts",
		"message_must_have_at_least_one_recipient": "Message must have at least one recipient",
		"confirm_details": "Confirm message details",
		"confirm_details_guide": "Make sure everything is correct before sending the message.",
		"back": "Back",
		"selected": "selected",
		"remove_message": "Remove draft",
		"really_remove_message": "Do you really want to remove this draft?",
		"deleted": "Removed",
		"none_selected": "None selected",
		"selected_rows": "Modify selected",
		"delete_selected": "Remove selected",
		"remove_messages": "Remove drafts",
		"really_remove_messages": "Do you really want to remove selected drafts?",
		"remove_users": "Remove users",
		"really_remove_users": "Do you really want to remove selected users?",
		"delete": "Remove",
		"receiver_groups": "Receiver groups",
		"receiver_manual_contacts": "Manual receiver numbers",
		"sent_messages_guide": "Here you can view information about your sent messages. Click on a message to see a detailed delivery report. Recipient information is retained for the current and previous calendar year.",
		"sent_messages": "Message history",
		"status_draft": "Draft",
		"status_scheduled": "Scheduled",
		"status_waiting_to_be_sent": "Waiting to be sent",
		"status_ongoing": "Ongoing",
		"status_completed": "Completed",
		"status_error": "Error",
		"status_unknown": "Unknown",
		"successful_sends": "Delivered",
		"waiting_to_be_sent_count": "Waiting to be sent",
		"status": "Status",
		"time_sent": "Time sent",
		"single_message_history": "Message details",
		"single_message_history_guide": "Below you can see a detailed report of the delivery.",
		"is_scheduled": "Scheduled",
		"yes": "Yes",
		"no": "No",
		"error_details": "Error details",
		"errors": "Errors",
		"details_do_not_update_in_real_time": "Message details do not update in real time. Refresh this page to see up-to-date details.",
		"not_sent": "Not sent",
		"user_will_receive_an_email": "Added user will receive an email with a link to fill in their information.",
		"overview": "Overview",
		"recipient_details": "Recipient details",
		"sent": "Sent",
		"sending": "Sending",
		"information": "More information",
		"time_delivered": "Time delivered",
		"not_delivered": "Not delivered",
		"inactive_contacts_on_receivers": "Inactive or blocked contacts",
		"inactive_contacts_on_receivers_guide": "These recipients you have added are inactive or blocked and will not receive the message:",
		"continue": "Continue",
		"inactive": "Inactive",
		"active": "Active",
		"blocked": "Blocked",
		"select_substitutions": "Personalize the message",
		"expected": "expected",
		"add_marketing_block": "Add marketing opt-out link",
		"adding_marketing_block": "Adding a marketing opt-out",
		"marketing_block_guide_1": "You can add a personalized link to your messages that allows the recipient to add their phone number to a block list. Numbers added to the block list will no longer receive messages from your user account.",
		"marketing_block_guide_2": "Hi, today all products are 20% off for loyalty customers. Opt out of marketing {{stopLink}}",
		"marketing_block_guide_3": "In the above example, the {{stopLink}} term is replaced with a recipient-specific URL that allows the person to block marketing. The URL is 27 characters long and this character count is deducted from the total available message length. The URL follows the format tavoittaja.fi/s/xxxxxxxx/xx.",
		"marketing_block_guide_4": "This service is free for all our customers.",
		"add": "Add opt-out link",
		"custom_fields_guide": "Custom fields",
		"label": "Label",
		"add_custom_field": "Add custom field",
		"remove_custom_field": "Remove custom field",
		"really_remove_custom_field": "Do you really want to remove this custom field?",
		"error_occurred": "Error occurred",
		"drag_and_drop_file_here": "Press here or data and drop file here",
		"supported_file_types": "Supported file types",
		"upload_file": "Upload file",
		"choose_columns": "Choose columns",
		"confirm_import": "Confirm import",
		"start_over": "Start over",
		"previous": "Previous",
		"next": "Next",
		"map_to_column": "Map to column",
		"column_data": "Column data",
		"description": "Description",
		"ignore": "Ignore",
		"select": "Select",
		"imports": "Imports",
		"original_file_name": "Original file name",
		"error_message": "Error message",
		"remove_contact": "Remove contact",
		"really_remove_contact": "Really remove this contact?",
		"removed": "Removed",
		"remove_contacts": "Remove contacts",
		"really_remove_contacts": "Really remove selected contacts?",
		"remove_groups": "Remove groups",
		"really_remove_groups": "Really remove selected groups?",
		"really_remove_group": "Really remove this group?",
		"remove_group": "Remove group",
		"no_custom_fields_found": "Start by creating a new custom field",
		"no_contacts_found": "start by creating or importing contacts",
		"no_groups_found": "Start by creating a new group",
		"no_imports_found": "No imports found",
		"no_orders_found": "No orders found",
		"no_messages_found": "No messages found",
		"no_recipients_found": "No recipients found",
		"no_drafts_found": "No drafts found",
		"no_inbound_numbers_found": "No inbound numbers found",
		"no_users_found": "Start by creating users",
		"no_search_results_with": "No search results with",
		"superadmin_login": "Superadmin login",
		"superadmin": "Superadmin",
		"sms_messages": "SMS Messages",
		"accounts": "Accounts",
		"orders": "Orders",
		"accounts_guide": "Here you can log into accounts, add credits to accounts, or remove them.",
		"waiting_for_approval": "Waiting for approval",
		"rejected": "Rejected",
		"approved": "Approved",
		"locked": "Locked",
		"unknown": "Unknown",
		"business_id": "Business ID",
		"remove_accounts": "Remove selected accounts",
		"really_remove_accounts": "Are you sure you want to remove the selected accounts?",
		"no_accounts_found": "No accounts found",
		"login_to_account": "Log in",
		"logged_in_as": "Logged in as",
		"accounts_waiting_for_approval": "These accounts are waiting for approval",
		"no_new_registered_accounts_waiting_for_approval": "No new accounts waiting for approval.",
		"approve": "Approve",
		"dont_approve": "Reject",
		"time_modified": "Time modified",
		"remove_custom_fields": "Remove custom fields",
		"really_remove_custom_fields": "Really remove selected custom fields?",
		"custom_fields_info_text": "You can add and edit fields in the Custom Fields tab",
		"no_custom_fields": "No custom fields",
		"basic_information": "Basic Information",
		"edit_contact": "Edit Contact",
		"time_latest_login": "Latest login",
		"never_logged_in": "Never logged in",
		"used_credits": "Credits",
		"unsubscribe": "Deny marketing",
		"subscribe": "Allow marketing",
		"really_unsubscribe": "Block marketing from {{account}} to number {{number}}?",
		"really_subscribe": "Allow marketing from {{account}} to number {{number}}?",
		"subscribe_success": "Marketing allowed!",
		"unsubscribe_success": "Marketing blocked!",
		"filters": "Filters",
		"close": "Close",
		"clear_all_filters": "Clear all filters",
		"invalid_sender": "The sender's name can be up to 11 characters long and can only contain letters, numbers, dots, dashes and spaces (no accents), or a phone number. This is a technical limitation of SMS messaging, not a restriction set by Tavoittaja.",
		"open_order": "Open order",
		"download_receipt": "Download as PDF",
		"generating_pdf": "Generating PDF...",
		"after": "After",
		"before": "Before",
		"select_date": "Select date",
		"no_items": "No items",
		"marketing_block": "Marketing opt-out link",
		"adding_manual_entries_to_contacts_list": "New numbers",
		"adding_manual_entries_to_contacts_list_guide": "You have manually added numbers that are not saved in your contacts. You can now add more details to them so they can be found later, for example, by name.",
		"add_details": "Add details",
		"done": "I’ve added the details I wanted",
		"general_fields": "General fields",
		"go_back_to_previous_page": "Back to previous page",
		"no_groups": "No groups",
		"add_to_groups": "Add to groups",
		"add_selected_contacts_to_groups": "This action will add the selected contacts to the chosen groups.",
		"choose_groups": "Choose groups",
		"remove_from_groups": "Remove from groups",
		"remove_selected_contacts_from_groups": "This action will remove the selected contacts from the chosen groups.",
		"reject_account": "Reject account",
		"really_reject_account": "Are you sure you want to reject this account? Write the reason below.",
		"reject": "Reject",
		"approve_account": "Approve account",
		"really_approve_account": "Do you want to approve this account?",
		"remove_account": "Remove account",
		"really_remove_account": "Do you want to remove this account?",
		"account_access": "Accounts",
		"superadmins": "Superadmins",
		"superadmins_guide": "Add, modify and remove superadmins.",
		"add_superadmin": "Add superadmin",
		"discount_codes": "Discount codes",
		"time_start": "Time start",
		"time_end": "Time end",
		"no_discount_codes_found": "No dicount codes found",
		"code": "Code",
		"discount_percentage": "Discount percentage",
		"usage_limit": "Usage limit",
		"add_discount_code": "Add discount code",
		"leave_empty_for_no_limit": "Leave empty for no limit",
		"monthly_sales": "Sales (0% VAT)",
		"january": "January",
		"february": "February",
		"march": "March",
		"april": "April",
		"may": "May",
		"june": "June",
		"july": "July",
		"august": "August",
		"september": "September",
		"october": "October",
		"november": "November",
		"december": "December",
		"monthly_credits_spent": "Credits spent",
		"monthly_messages_sent": "Messages sent",
		"getting_started": "Getting started",
		"here_is_how_to_get_started": "Welcome to use Tavoittaja. Here's how to get started:",
		"buy_credits_guide_step": "Buy credits",
		"buy_credits_desc": "You need credits to send messages. A general rule of thumb is, that one message costs one credit.",
		"add_contacts_guide_step": "Add contacts",
		"add_contacts_desc": "Add or import some contacts you would like to send messages to.",
		"send_message_guide_step": "Send your first message",
		"send_message_guide_desc": "After doing the previous steps, you are ready to send your first messages!",
		"no_sms_message_templates_found": "No sms message templates found",
		"remove_message_templates": "Remove message templates",
		"really_remove_message_templates": "Are you sure you want to remove selected message templates?",
		"time_latest_message_sent": "Time latest message sent",
		"time_credits_expire": "Credits expire",
		"id": "ID",
		"edit_superadmin": "Edit superadmin",
		"announcements": "Announcements",
		"announcements_guide": "Technical bulletins and service update announcements.",
		"no_announcements": "No announcements",
		"title": "Title",
		"content": "Content",
		"news": "News",
		"change_log": "Update",
		"remove_announcement": "Remove announcement",
		"really_remove_announcement": "Are you sure you want to remove this announcement?",
		"remove_announcements": "Remove announcements",
		"type": "Type",
		"no_announcements_found": "No announcements found",
		"add_announcement": "Add announcement",
		"really_remove_announcements": "Are you sure you want to remove the selected announcements?",
		"payment_status": "Payment status",
		"unable_to_fetch_announcements": "Unable to fetch announcements. Try again later.",
		"save_changes": "Save changes",
		"expected_credit_usage": "Credits",
		"not_enough_credits": "Not enough credits",
		"add_or_remove_credits": "Modify credits",
		"modify_credits": "Modify credits",
		"add_credits": "Add",
		"remove_credits": "Remove",
		"amount": "Amount",
		"credits_removed": "Credits removed",
		"credits_added": "Credits added",
		"monthly_accounts_created": "New accounts",
		"add_message_template": "Add message template",
		"add_sms_message_template": "Add message template",
		"really_remove_sms_message_template": "Are you sure you want to delete the message template?",
		"remove_sms_message_template": "Delete message template",
		"sms_message_template_added": "Message template created",
		"send_message_using_template": "Send message using template",
		"users_name": "User's name",
		"users_phone": "User's phone number",
		"users_email": "User's email address",
		"i_just_tried_to_do_something_very_silly": "I just tried to do something very silly!",
		"use_as_template": "Use as template",
		"threshold": "Threshold",
		"price_per_credit": "Price per credit",
		"pricing": "Pricing",
		"more_you_buy_cheaper": "The more you buy, the cheaper the credits.",
		"active_description": "Regular status. This contact can receive sms.",
		"inactive_description": "This contact should no longer receive sms.",
		"blocked_description": "Recipient has unsubscribed and no sms should be sent to them.",
		"time_active_start": "Active from",
		"time_active_end": "Active until",
		"active_reservation": "In use on the account",
		"add_inbound_number": "Add inbound number",
		"edit_inbound_number": "Edit inbound number",
		"no_active_reservation": "Not in use",
		"is_enabled": "Enabled",
		"click_to_select_date": "Click to select date",
		"inbound_number_reservations": "Inbound number reservations",
		"add_inbound_number_reservation": "Add reservation",
		"no_inbound_number_reservations_found": "No reservations found",
		"inbound_number": "Inbound number",
		"edit_inbound_number_reservation": "Edit reservation",
		"messaging_history": "Messaging History",
		"message_from_contact": "Message from Contact",
		"message_to_contact": "Message to Contact",
		"message_name": "Message Name",
		"inbound_messages": "Inbound Messages",
		"inbound_messages_desc": "Messages received to sending numbers are shown here.",
		"export": "Export to Excel",
		"time_received_before": "Time received Before",
		"time_scheduled": "Scheduled to send at",
		"not_scheduled": "Not scheduled",
		"number_of_contacts": "Contacts in group",
		"select_columns_to_export": "Select columns to export",
		"time_unsubscribed": "Marketing opt-out set",
		"created_from": "Created from",
		"select_all": "Select all",
		"api_key_generated": "Your API key has been generated. Please copy and store it securely now — you won't be able to view it again.",
		"copied_to_clipboard": "Copied to clipboard",
		"generate_api_key": "Generate API Key",
		"generate": "Generate",
		"surveys": "Surveys",
		"add_survey": "Create survey",
		"no_surveys_found": "Start by creating a new survey",
		"time_submit_start": "Scheduled to open",
		"time_submit_end": "Scheduled to close",
		"surveys_guide": "You can create surveys, for example, to collect feedback.",
		"add_survey_guide": "You can create surveys, for example, to collect feedback, and you can attach a link to the surveys in text message campaigns. You can later edit the information you set during survey creation in the survey’s Settings tab.",
		"create": "Create",
		"draft": "Draft",
		"submissions": "Submissions",
		"edit_fields": "Edit fields",
		"reports": "Reports",
		"settings": "Settings",
		"submissions_guide": "Browse your survey submissions from the list below. You can export all submissions to an Excel file by clicking the Export to Excel button.",
		"no_submissions_found": "No submissions",
		"edit_fields_guide": "You can add new fields to your survey by dragging them from the right-hand column. Edit a field by clicking its pencil icon.",
		"default_fields": "Default fields",
		"multiple_choices": "Multiple choice",
		"open_answers": "Open answers",
		"ratings": "Rating scales",
		"survey_structure": "Survey structure",
		"choose_one": "Choose one",
		"text": "Text field",
		"number": "Number field",
		"date": "Date",
		"smiley": "Smiley",
		"star": "Star",
		"scale": "Rating",
		"nps": "NPS",
		"divider": "Divider",
		"page_break": "Page break",
		"paragraph": "Paragraph",
		"textarea": "Multi-line text field",
		"start_by_dragging_elements": "Start by dragging fields from the right-hand column.",
		"no_translation": "Translation missing",
		"remove_field": "Remove field",
		"really_remove_field": "Are you sure you want to remove this field? If the survey has already been answered, the submissions related to this field will no longer be available. To preserve the submissions, hide the field instead of removing it.",
		"reports_guide": "Reports",
		"settings_guide": "Edit the survey's general settings, activity, and appearance.",
		"placeholder": "Placeholder",
		"add_field": "Add field",
		"min": "Minimum",
		"max": "Maximum",
		"drop_here": "Drop here",
		"options": "Options",
		"add_option": "Add Option",
		"option_label": "Option Text",
		"select_one": "Select One",
		"finnish": "Finnish",
		"english": "English",
		"swedish": "Swedish",
		"en": "English",
		"fi": "Finnish",
		"select_many": "Select Multiple",
		"survey_heading": "Survey Heading",
		"only_used_internally": "Used only as an internal identifier, not shown to respondents.",
		"enabled": "Enabled",
		"disabled": "Disabled",
		"scheduled": "Scheduled",
		"scheduling_survey": "Scheduling Survey",
		"schedule_survey": "Schedule Survey",
		"unsaved_changes": "You have unsaved changes",
		"custom_css": "Custom CSS",
		"custom_css_guide": "You can customize the survey styles manually by writing CSS. Documentation on CSS can be found online.",
		"general_settings": "General Settings",
		"text_before_survey": "Text before the survey",
		"text_after_survey": "Text after the survey",
		"survey_visuals": "Survey Visuals",
		"color_scheme": "Color Scheme",
		"logo": "Logo",
		"upload_logo": "Upload Logo",
		"survey_status": "Survey Status",
		"survey_not_found": "Survey not found",
		"make_sure_link_is_correct": "Make sure the link has been copied in its entirety.",
		"start": "Start",
		"submit": "Submit",
		"check_answers": "Check answers and press submit button",
		"open_survey": "Open survey preview",
		"answer_sent": "Thank you for your response!",
		"content_and_languages": "Content and languages",
		"visuals": "Survey appearance",
		"empty_base": "Empty template",
		"previously_created_survey": "Previously created survey",
		"select_base_for_survey": "Select a base for your survey",
		"survey_internal_name": "Survey internal name",
		"select_survey": "Select survey",
		"status_desc": "When creating a new survey, its status is always set to “Active”. You can edit the status in the survey’s Settings tab.",
		"heading_and_before_text": "Heading and introductory text",
		"heading_and_before_text_desc": "The survey heading and introductory text are shown on the survey start page below the logo. Without these, the survey start page is not available.",
		"after_text": "Closing text",
		"after_text_desc": "The closing text is shown to the respondent after completing the survey.",
		"add_language": "Add language",
		"color_scheme_desc": "The survey’s color theme defines the color of buttons and multiple-choice fields.",
		"logo_desc": "The logo is displayed at the top of every survey page.",
		"recommended_size": "Recommended size",
		"recommended_size_desc": "Horizontal, 300px wide",
		"max_file_size": "Maximum file size",
		"allowed_extensions": "Allowed file formats",
		"coming_soon": "Coming soon",
		"remove_language": "Remove language",
		"save_all_settings": "Save all settings",
		"survey_not_fillable": "The survey has no fillable fields.",
		"min_options": "Select at least {{count}}",
		"max_options": "You can select at most {{count}}",
		"saving": "Saving...",
		"current_changes_might_not_be_saved": "The latest changes might not have been saved.",
		"remove_survey_submissions": "Remove submissions",
		"really_remove_survey_submissions": "Are you sure you want to remove the selected submissions?",
		"survey_not_fillable_time": "The survey is not open",
		"items": "Items",
		"invalid_discount_code": "Invalid discount code",
		"remove_discount_code": "Remove discount code",
		"looking_for_old_tavoittaja": "Looking for legacy Tavoittaja?",
		"fill_at_least_one_field": "Answer to at least one field",
		"contact_us_to_order": "Contact us to order",
		"is_invoicing_enabled": "Account can buy credits using invoice as payment method",
		"used_times": "Times used",
		"link_to_survey": "Link to survey",
		"add_survey_link": "Add survey link",
		"remove_surveys": "Remove surveys",
		"really_remove_surveys": "Do you really want to remove the selected surveys?",
		"is_summary_page_shown": "Show submission summary as last page",
		"select_at_least": "Select at least",
		"select_maximum": "Select at most",
		"field_type": "Field type",
		"one_line": "Single-line text field",
		"text_area": "Multi-line text field",
		"country": "Country",
		"procountor_business_partner_identifier": "Procountor Business Partner Identifier",
		"e_invoice_address": "E-invoice Address",
		"e_invoice_intermediate_id": "Intermediate ID",
		"invoice_reference": "Reference / Cost Center",
		"contact": "Contact",
		"credits_at_the_moment": "Credit amount",
		"submission": "Submission",
		"user_guide": "User guide",
		"basic_details": "Basic Details",
		"invoicing_details": "Invoicing Details",
		"remove_survey_submission": "Remove submission",
		"really_remove_survey_submission": "Are you sure you want to remove this submission",
		"missing_required_fields": "Please fill in all required fields also for the other languages.",
		"credit_usage_pricing": "Credit usage in sending",
		"message_length": "Message length",
		"price_per_message": "Credits used per message",
		"location": "Location",
		"finland": "Finland",
		"nordics_and_baltic": "Nordics and Baltics",
		"usa_and_rest_of_europe": "USA and rest of Europe",
		"credit_usage_desc": "Credit usage is based on content length, so the message you send may actually consist of multiple messages. In the table below, you can see how length affects credit usage.",
		"above_only_for_finland": "Note: the above table applies to Finnish domestic messages. Below you can see how the recipient’s country affects credit usage.",
		"other_countries": "Other countries",
		"credit_amount": "credit amount",
		"credits_lower_case": "credits",
		"from_ui": "From UI",
		"from_import": "From Imports",
		"api_message_history": "Message History (API)",
		"sent_messages_guide_api": "Here you can view details of messages sent via the API. You can see a detailed delivery report by clicking on a message. Recipient information is retained for the current and previous calendar year.",
		"set_billing_email": "Set a billing email for your account from the 'Account' menu to purchase credits",
		"hidden": "Hidden",
		"min_max_guide": "With minimum and maximum, you can specify how many options a respondent can select.",
		"status_message": "Raw operator status message",
		"old_email": "Enter the email address you used in the old version. You can leave the field empty if you don’t know or remember it.",
		"request_credit_transfer": "I request credits to be transferred from the old version to this version. The transfer will be completed within one business day at the latest.",
		"nothing_to_export": "Nothing to export",
		"add_contact_to_preview": "Add at least one contact for preview",
		"pay": "Order",
		"file_too_large": "File is too large",
		"use_inbound_number": "Use sending number",
		"api_documentation": "API documentation",
		"automatic_credit_purchase": "Automatic credit purchase",
		"add_card": "Add payment card",
		"add_card_first": "Start by adding a payment card to be charged for credit purchases",
		"remove_api_key": "Remove API key",
		"really_remove_api_key": "Are you sure you want to remove the API key?",
		"no_api_keys_found": "Start by creating an API key",
		"remove_card": "Remove card",
		"automatic_credit_purchase_guide": "With automatic credit purchases, you can set a minimum credit balance for your account. Once your balance drops below set level, the system will automatically purchase your chosen number of credits.",
		"really_remove_card": "Are you sure you want to remove the card? Automatic credit purchases will stop working.",
		"auto_purchase_credit_threshold": "Minimum balance at which credits are purchased",
		"auto_purchase_credit_amount": "Amount to be purchased",
		"api_keys": "API keys",
		"buyer": "Buyer:",
		"place_order": "Order credits",
		"really_place_order": "Are you sure you want to order credits?",
		"auto_purchase_settings": "Settings",
		"always_active": "Minimum balance at which credits are purchased",
		"always_active_desc": "With automatic credit purchases, you can set a minimum credit balance for your account. Once your balance drops below set level, the system will automatically add your chosen number of credits. The system will purchase more credits if the SMS message requires more than the amount you have selected.",
		"is_automatic_payments_enabled": "Automatic credit purchase enabled",
		"card_accepted": "Card accepted",
		"card_declined": "Card declined",
		"successful_imports": "Successful rows",
		"skipped_imports": "Skipped rows",
		"failed_imports": "Failed rows",
		"import_details": "Import details",
		"import_status_message": "Error message",
		"line_number": "Line number",
		"time_imported": "Imported",
		"skipped": "Skipped",
		"completed": "Completed",
		"error": "Error",
		"we_do_not_store_card_info": "The recipient does not store payment card information.",
		"payment_provider": "The payment service provider is Paytrail",
		"send_notification_email": "I want to receive an email notification when the import is ready",
		"non_valid_email_will_be_skipped": "If the email address is not valid, the row will be imported without it.",
		"no_import_rows": "No rows",
		"following_are_invalid": "Invalid numbers",
		"bar": "Bar chart",
		"line": "Line chart",
		"total_this_year": "Total this year:",
		"month": "Month",
		"average_per_month": "Average per month",
		"request_invoicing": "Request invoicing rights",
		"interested_in_invoicing": "Can I pay by invoice?",
		"really_request_invoicing": "If you want to pay credit orders by invoice, send us a request using the button below. We will contact you as soon as possible.",
		"really_request_invoicing_invoice_fee": "Invoicing fee is 9,90 € per order.",
		"send_invoicing_request": "Request invoicing rights",
		"thank_you_we_will_contact_you_soon": "Thank you! We will contact you as soon as possible.",
		"order_status": "Order status",
		"send_survey_via_message": "Send survey",
		"add_new_custom_field": "Add new custom field",
		"all_on_page_selected": "All rows on this page are selected.",
		"all_selected": "All rows are selected.",
		"clear_selection": "Clear selections",
		"invoice_contact_name": "Billing contact person",
		"invoice_delivery_method": "Invoice delivery method",
		"e_invoice": "E-invoice",
		"discount_code": "Used discount code",
		"purchaser_name": "Purchaser name",
		"checkout_payment_status": "Checkout payment status (Paytrail)",
		"add_individual_recipients": "Add individual recipients",
		"or_add_new_contacts": "Add new contacts",
		"confirm_adding_new_contacts": "Confirm adding new contacts",
		"choose_from_existing": "Or choose from existing contacts",
		"add_recipient_groups": "Add recipient groups",
		"these_amounts_are_only_expected_amounts": "The amounts above are estimates. You’ll see the final figures in the next step.",
		"special_characters_found": "Note! Your message contains special characters that may cause it to use more credits:",
		"encoding": "Encoding",
		"message_count": "Sending as {{count}} separate message(s) due to its length",
		"remove_scheduling": "Remove scheduling and change the message to a draft",
		"remove_scheduling_and_send_now": "Remove scheduling and send now",
		"really_send_scheduled_message_now": "The message will be sent immediately to {{count}} recipient(s). Do you want to continue?",
		"delivery_report_url": "Webhook delivery report URL",
		"time_received_after": "Time received after",
		"false": "No",
		"ui": "UI",
		"choose_multiple": "Choose multiple",
		"duplicate_account": "Account already exists with business id",
		"duplicate_account_verify": "An account with this business ID already exists. Do you still want to approve this account as well?",
		"enable": "Enable automatic credit purchase",
		"choose_payment_method": "Choose payment method",
		"remove_payment_method": "Remove payment method",
		"really_remove_payment_method": "Are you sure you want to remove this payment method?",
		"contact_first_name": "Contact's first name",
		"contact_last_name": "Contact's last name",
		"contact_full_name": "Contact's full name",
		"contact_phone": "Contact's phone number",
		"contact_company": "Contact's company",
		"webhook_secret": "Webhook secret",
		"sv": "Swedish",
		"inbound_number_documentation": "Documentation",
		"decline_reason": "Reason for rejected/locked",
		"allowed_characters": "An authorized name or number. You can also use the service's authorized sender name, Tavoittaja.",
		"use_international_format": "If you use a phone number as sender, enter the number in international format +358501234567.",
		"you_can_also_use_inbound_number": "You can also use an inbound number, which allows for replying to messages.",
		"add_recipients_law_guide_1": "Sending text messages falls under Finnish legislation and is considered marketing communication.",
		"add_recipients_law_guide_2": "You must not send text messages to private individuals without their prior consent.",
		"add_recipients_law_guide_3": "You can read more about the legislation on the website of the Ministry of Transport and Communications.",
		"remove_imports": "Remove imports from history",
		"really_remove_imports": "Are you sure you want to remove the selected imports from history? This will not delete the imported contacts.",
		"import_rows": "Import Rows",
		"mapping_fields": "Columns",
		"open_contact": "Open contact details",
		"previously_used": "Previously used",
		"you_previously_used": "Use previously used sender: {{number}}",
		"allowed_traficom_sender_names": "Sender names normally blocked by Traficom but allowed for this account",
		"other": "Other",
		"separate_multiple_names_with_commas": "Separate multiple names with commas",
		"change_status": "Change contacts statuses",
		"we_recommend_turning_on_automatic_payments": "We recommend turning on automatic credit purchase. This way you'll never run out of credits accidentally",
		"phone_must_be_10_char": "The phone number must be at least 10 digits long including the country code.",
		"expires_in": "Expires",
		"maybe_dont_use_spaces": "If you send messages abroad, we recommend not using special characters, as not all foreign operators support them.",
		"order_rows": "Order rows",
		"info_about_admin_role": "Admin can add and remove users.",
		"placeholder_in_use": "The number of credits is an estimate because the message has been personalized. You will see the exact amount in the next step.",
		"buy_more_credits": "Buy more credits",
		"exporting_rows": "Exporting {{count}} rows",
		"export_count": "Export to Excel ({{count}})",
		"sending_status": "Sending status",
		"delivered": "Delivered",
		"processing": "Processing",
		"failed": "Failed",
		"message_preferences": "Message preferences",
		"is_informational_messages_allowed": "I want to receive informational messages",
		"is_marketing_messages_allowed": "I want to receive marketing messages",
		"user": "User information",
		"users_guide_tab": "",
		"this_will_send_emails_to_all_account_users": "Enabling this will send an email to all account users who have opted in to informational messages.",
		"is_active": "Active on account {{account}}",
		"is_not_active": "Not in use",
		"comment": "Comment",
		"add_automatic_payment_method": "Add another",
		"add_payment_method": "Add automatic payment method",
		"card": "Card",
		"add_comment": "Add comment",
		"external_id": "External ID",
		"sender_name_type": "Sender Name Type",
		"authorization_level": "Authorization Level",
		"company_name": "Company Name",
		"company_website": "Company Website",
		"contact_person_name": "Contact Person Name",
		"purposes": "Purposes",
		"primary_purpose": "Primary Purpose",
		"secondary_purpose": "Secondary Purpose",
		"tertiary_purpose": "Tertiary Purpose",
		"none": "None",
		"trust": "Trust",
		"transactional": "Transactional",
		"promotional": "Promotional",
		"alphanumeric": "Alphanumeric",
		"registered": "Registered",
		"authorized": "Authorized",
		"processing_prospectum": "Processing Prospectum",
		"processing_my_link": "Processing MyLink",
		"reject_reason": "Reject Reason",
		"create_sender_name": "Create Sender Name",
		"edit_sender_name": "Edit Sender Name",
		"created": "Created successfully",
		"updated": "Updated successfully",
		"sender_names": "Sender names",
		"sender_names_guide": "Following Traficom’s new regulation (28 L/2025), all organizations sending text messages must authorize their sender IDs. Messages sent with an unauthorized sender ID may be delivered with the sender name shown as ‘Unknown’. Authorization is free of charge for our customers, and it will be processed within 10 business days.",
		"add_sender_name": "Add sender name",
		"request_new_sender_name": "Authorize a new sender name",
		"no_sender_names_found": "No sender names found",
		"remove_sender_names": "Remove sender names",
		"really_remove_sender_names": "Really remove all selected sender names?",
		"tell_us_your_sender_name": "In Tavoittaja, sender names can be approved free of charge",
		"after_46_will_be_unknown": "We have decided that new approvals will be free for our customers. Approvals are processed within 10 business days.\nCustomers must make sure sender names work with all operators.",
		"read_info_sender_name": "Read the notice",
		"sender_name": "Sender name",
		"sender_name_case_sensitive": "Authorization is case sensitive (e.g. \"Tavoittaja\" and \"TAVOITTAJA\" are different sender names). Type the sender name exactly as you want it to appear to the recipient.",
		"sender_name_cannot_be_updated_anymore": "This sender name is already being processed, and it cannot be updated.",
		"accepted": "Accepted",
		"select_or_type_name": "Select from this list or type a new one",
		"select_name": "Select a sender name from the list",
		"usage_explanation": "Usage explanation",
		"usage_explanation_helper": "Explain what the sender name is used for. Especially important when authorizing a customer's sender name.",
		"senders_name": "Sender name or number",
		"authorize_sender_name": "Authorize your sender names",
		"maybe_later": "Maybe later",
		"authorize_now": "Authorize now (this message has been saved)",
		"processing_s": "Processing",
		"remove_sender_name": "Remove sender name",
		"really_remove_sender_name": "Really remove this sender name?",
		"is_your_sender_name_type_correct": "Is your sender name type correct?",
		"sender_name_looks_like_phone_number": "You've set type as alphanumeric, but the set name only contains 0-9, +, and space characters.",
		"its_correct": "It's correct - Not a phone number",
		"no_go_back": "It's wrong, go back",
		"contact_name": "Contacts name",
		"have_read_privacy_policy": "I have read and accepted ",
		"privacy_policy": "privacy policy",
		"privacy_policy_sidebar": "Privacy policy",
		"resend": "Resend",
		"resend_message": "Resend message",
		"really_resend_message": "Do you really want to resend this message?",
		"message_sent": "Message sent",
		"close_modal": "Close",
		"notice_when_sending_abroad": "If you send messages abroad, please note that sender name restrictions vary by country. See an indicative list",
		"here": "here",
		"contact_not_found": "Contact not found",
		"contact_not_found_explanation": "This contact is no longer available to view, and it may have been deleted.",
		"no_sender_names": "No authorized sender names",
		"account_has_no_sender_names": "Your account does not yet have any authorized sender names. Authorization is required to send messages.",
		"authorize": "Authorize now",
		"password_must_contain_uppercase_lowercase_and_number": "Password must contain at least one uppercase letter, one lowercase letter, and one number.",
		"set_invoice_delivery_method": "Set invoice delivery method on account settings",
		"invoicing_fee": "{{amount}} €"
	},
	"contacts": {
		"browse_contacts": "Browse contacts",
		"browse_contacts_desc": "Browse all contacts",
		"add_contact": "Add contact",
		"import_contacts": "Import contacts",
		"import_contacts_desc": "Import new or update existing contacts from files.",
		"groups_desc": "Groups help you organize the contacts for easier handling",
		"add_group": "Add group",
		"add_to_groups": "Add to groups",
		"import_name": "Import name",
		"create_new_group": "Create new group",
		"create_new_group_desc": "Add each imported contact to a selected group or to multiple groups",
		"default_country_code": "Default country code",
		"default_country_code_desc": "Numbers starting with 0 will be replaced by this code by default",
		"import_only_new_contacts": "Import only new contacts",
		"import_only_new_contacts_desc": "If this is on, already existing contacts are not updated, only new ones are added.",
		"how_is_contact_data_updated": "How is contact data updated",
		"contact_data_update_desc": "Choose how existing contact's information is updated",
		"overwrite_old_data": "Overwrite old data",
		"add_only_new_properties": "Add only new properties",
		"is_first_row_header": "Is first row header",
		"is_first_row_header_desc": "If the first item in the each column's data is the header (e.g. phone or email) this should be toggled on",
		"phone_number_is_needed_to_continue": "You need to select at least phone number column to continue",
		"import_process_started_in_background": "Import process started in the background.",
		"import_status_refreshes_automatically": "This view refreshes automatically when the import is finished.",
		"import_completed": "Import completed",
		"import_failed": "Import failed",
		"property_updating_method": "Property updating method",
		"is_importing_new_only": "Is importing new only",
		"imports_desc": "Browse and view all your imports",
		"show_imports": "Show imports",
		"contact_added": "Contact added",
		"group_added": "Group added"
	},
	"messages": {
		"time_sent_after": "Time sent after",
		"time_sent_before": "Time sent before",
		"deliver_details": "Delivery details",
		"sending_in_progress": "Sending in process",
		"sending_failed": "Sending failed",
		"continue_to_choose_recipients": "Continue to select recipients",
		"credit_cost": "Credit cost",
		"per_message": "per message",
		"save_draft": "Save draft",
		"edit_message_content": "Edit message content",
		"choose_recipients": "Choose recipients",
		"confirm_send": "Confirm send",
		"message_scheduled_successfully": "Message has been scheduled successfully",
		"message_sending_started_successfully": "Message sending process has started successfully",
		"view_more_info_from_details": "You can view more details about the message sending process by going to the message details page",
		"go_back_to_drafts": "Go back to drafts",
		"go_to_message_details": "Go to message details",
		"time_is_required": "Time is required",
		"select_one_action": "Select action",
		"total_recipients": "Total recipients",
		"confirm_schedule": "Confirm schedule",
		"select_from_existing_contacts": "Select from existing contacts",
		"name_is_for_internal_use": "Name is for internal use only, it is not shown to recipients",
		"you_will_run_out_of_credits": "Not enough credits for scheduled messages",
		"scheduled_messages_out_of_credits": "You no longer have enough credits for your scheduled messages – you are missing {{missingCredits}} credits."
	}
}
